<template>
  <StaffLayout section="Clients" showHeader>
    <div v-if="isLoading"><Loading /></div>
    <div v-else>
      <div v-if="clients && clients.length > 0">
        <AddButton @click="addClick">Add Client</AddButton>
        <div
          class="px-4 py-2 my-2 bg-gray-100 border-t cursor-pointer hover:bg-blue-200"
          v-for="client in clients"
          :key="client.clientId"
          @click="clientClick(client)"
        >
          {{ client.name }}
        </div>
      </div>
      <div v-else class="mb-2">-- No Clients found --</div>
      <div class="pt-1">
        <AddButton @click="addClick">Add Client</AddButton>
      </div>
    </div>
    <EditPopup
      entity-name="Client"
      :is-visible="isPopupVisible"
      :is-edit-mode="false"
      :save-error="saveError"
      :delete-enabled="false"
      @close="isPopupVisible = false"
      @save="saveClick"
    >
      <BaseInput
        label="Client Name"
        v-model="clientName"
        type="text"
        :error="errors.clientName"
      />
      <BaseInput
        label="System Name"
        v-model="systemName"
        type="text"
        :error="errors.systemName"
      />
      <BaseInput
        label="Expire After Months"
        v-model="expireAfterMonths"
        type="number"
        :error="errors.expireAfterMonths"
      />
      <BaseInput
        label="Minimum Score Passes"
        v-model="minimumScorePasses"
        type="number"
        :error="errors.minimumScorePasses"
      />
      <BaseInput
        label="Category Alias"
        v-model="categoryAlias"
        type="text"
        :error="errors.categoryAlias"
      />
      <BaseInput label="Notes" v-model="note" type="text" />
    </EditPopup>
  </StaffLayout>
</template>

<script setup lang="ts">
import { useAdminStore } from "../../store/adminStore";
import { ClientDTO, SaveClientCommand } from "../../store/generatedFetchClient";
import router from "../../router";
import { cleanString } from "../../helpers/index";

import { useField, useForm } from "vee-validate";
import * as yup from "yup";

let isLoading = ref(true);
const adminStore = useAdminStore();

onMounted(async () => {
  console.log("Clients Admin Page mounted");
  isLoading.value = true;
  await adminStore.getClientList();
  isLoading.value = false;
});

// Popup stuff
const isPopupVisible = ref(false);
let saveError = ref("");

const { handleSubmit, errors } = useForm({
  validationSchema: yup.object({
    clientName: yup.string().required().max(100).label("Client Name"),
    systemName: yup
      .string()
      .required()
      .min(3)
      .max(100)
      .matches(/^[^\ \'\.\,\&\n\"]+$/, {
        message:
          "System Name cannot contain special characters such as spaces and quotes",
      })
      .label("System Name"),
    expireAfterMonths: yup
      .number()
      .typeError("Expire After Months is a required field")
      .required()
      .label("Expire After Months"),
    minimumScorePasses: yup
      .number()
      .typeError("Minimum Score Passes is a required field")
      .required()
      .label("Minimum Score Passes"),
    categoryAlias: yup.string().required().max(50).label("Category Alias"),
  }),
  initialValues: {
    clientName: "",
    systemName: "",
    expireAfterMonths: 12,
    minimumScorePasses: 80,
    categoryAlias: "Region",
  },
});

let clientId = ref(-1);
const { value: clientName } = useField<string>("clientName");
const { value: systemName } = useField<string>("systemName");
const { value: expireAfterMonths } = useField<number>("expireAfterMonths");
const { value: minimumScorePasses } = useField<number>("minimumScorePasses");
const { value: categoryAlias } = useField<string>("categoryAlias");
let note = ref("");

watch(clientName, (newClientName, oldClientName) => {
  if (systemName.value == "" || systemName.value == cleanString(oldClientName))
    systemName.value = cleanString(newClientName);
});

let saveClick = handleSubmit(onValidSubmit, onInvalidSubmit);

async function onValidSubmit() {
  let saveClient = {
    clientId: clientId.value,
    systemName: systemName.value,
    name: clientName.value,
    expireAfterMonths: expireAfterMonths.value,
    minimumScorePasses: minimumScorePasses.value,
    categoryAlias: categoryAlias.value,
    note: note.value,
  } as SaveClientCommand;

  console.log("saving client", saveClient);

  saveError.value = "";
  saveError.value = await adminStore.saveClient(saveClient);
  if (!saveError.value) {
    isPopupVisible.value = false;
  }
}

function onInvalidSubmit(ctx: any) {
  saveError.value = "One or more invalid form inputs.";
  console.log("error trying to submit form", ctx);
}

function clientClick(client: ClientDTO) {
  console.log("clicked client " + client.name + ": " + client.clientId);
  router.push(`/staff/client/${client.clientId}`);
}

function addClick() {
  saveError.value = "";

  clientId.value = 0;
  clientName.value = "";
  systemName.value = "";
  expireAfterMonths.value = 12;
  minimumScorePasses.value = 80;
  categoryAlias.value = "Region";
  note.value = "";

  isPopupVisible.value = true;
}

let clients = computed(() => {
  // if (adminStore.clients && adminStore.clients.length > 0) {
  //   isLoading.value = false;
  // }
  return adminStore.clients;
});
</script>
